var _path, _path2, _rect, _mask, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDomesticX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36ZM20 38C29.9411 38 38 29.9411 38 20C38 10.0589 29.9411 2 20 2C10.0589 2 2 10.0589 2 20C2 29.9411 10.0589 38 20 38Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8H23V11C23 12.6569 21.6569 14 20 14C18.3431 14 17 12.6569 17 11V8Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 21,
    width: 4,
    height: 7,
    stroke: "currentColor",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_809_8160",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 19H23V21V27V29H29V27H32V21L29 21V19Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19V17H21V19H23ZM29 19H31V17H29V19ZM23 29H21V31H23V29ZM29 29V31H31V29H29ZM29 27V25H27V27H29ZM32 27V29H34V27H32ZM32 21H34V19L32 19V21ZM29 21H27V23H29V21ZM23 21H29V17H23V21ZM25 21V19H21V21H25ZM25 27V21H21V27H25ZM25 29V27H21V29H25ZM29 27H23V31H29V27ZM27 27V29H31V27H27ZM32 25H29V29H32V25ZM30 21V27H34V21H30ZM29 23L32 23V19L29 19V23ZM27 19V21H31V19H27Z",
    fill: "currentColor",
    mask: "url(#path-4-inside-1_809_8160)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomesticX);
export default __webpack_public_path__ + "static/media/DOMESTIC_X.7d078a12b980072e53cc8bb2f0d956bc.svg";
export { ForwardRef as ReactComponent };